import { FormValues } from "@/schema/console/assessments/create/FormValues";
import { useFormContext, useWatch } from "react-hook-form";
import EditQuestion from "./EditQuestion";
import TextQuestion from "./TextQuestion";

interface QuestionProps {
  type: "simple" | "regular";
  index: number;
  categoryIndex: number;
  subCategoryIndex: number;
  onRemove: () => void;
}

function Question({
  index,
  type,
  categoryIndex,
  subCategoryIndex,
  onRemove,
}: QuestionProps) {
  //getfromcontext
  const { control } = useFormContext<FormValues>();

  const isEdit = useWatch({
    control,
    name: `categories.${categoryIndex}.subcategories.${subCategoryIndex}.questions.${index}.isEdit`,
  });

  return (
    <>
      {isEdit ? (
        <EditQuestion
          type={type}
          categoryIndex={categoryIndex}
          subCategoryIndex={subCategoryIndex}
          index={index}
        />
      ) : (
        <TextQuestion
          type={type}
          categoryIndex={categoryIndex}
          subCategoryIndex={subCategoryIndex}
          index={index}
          onRemove={onRemove}
        />
      )}
    </>
  );
}

export default Question;
